import React from 'react';
import styled from 'styled-components/macro';

type SecurityIcon = {
  imageUrl: string;
  imageAlt: string;
  linkUrl: string;
};

type Props = {
  className?: string;
  show?: boolean;
  items: SecurityIcon[];
};

export const SecurityIconsSection = (props: Props) => {
  const { className = '', show = true, items } = props;

  if (!show) return null;

  return (
    <StyledSecurityIconsSection className={`${className} security-icons-wrapper`}>
      <SecurityTitle className="container security-icons-title">
        <span>Guaranteed Safe & Secure Checkout</span>
      </SecurityTitle>
      <div className="container text-center">
        {items.map((item) => (
          <SecurityIconLink href={item.linkUrl} target="_blank" rel="noopener noreferrer" key={item.imageUrl}>
            <img src={item.imageUrl} alt={item.imageAlt} />
          </SecurityIconLink>
        ))}
      </div>
    </StyledSecurityIconsSection>
  );
};

const StyledSecurityIconsSection = styled.section`
  background-color: ${(props) => props.theme.splashOptional2 || props.theme.splashPrimary2};
  padding: 30px 0;
`;

const SecurityTitle = styled.div`
  overflow: hidden;
  text-align: center;

  span {
    color: black;
    display: inline-block;
    margin: 12px;
    position: relative;
    text-transform: uppercase;

    :before,
    :after {
      border-bottom: 1px solid #333;
      content: '';
      display: inline-block;
      position: absolute;
      top: 50%;
      width: 0;

      @media (min-width: 640px) {
        width: 150px;
      }

      @media (min-width: 768px) {
        width: 450px;
      }
    }

    :before {
      margin-right: 12px;
      right: 100%;
    }

    :after {
      left: 100%;
      margin-left: 12px;
    }
  }
`;

const SecurityIconLink = styled.a`
  margin: 0 12px;

  > img {
    width: 125px;

    @media (min-width: 992px) {
      width: 105px;
    }
  }
`;
